const PAYPAL_LIVE_CLIENT_ID =
    'AYIQtJCJjoJNsnvs6281wYkdOSvjfll1ceHibyRL4GS8xL2GPuPMjPYQOmjnLuA8k553uhGmSM0RtqdC';
const PAYPAL_SANDBOX_CLIENT_ID =
    'Admd3AL0K4YjzkC_-15JLRP-ASaMcWkXSw0aZN8jxeJz-0W2X89YniE_YkeCJcyV5KdVqXQqEiL9aCjC';

export type HostedEnvironment = 'development' | 'test' | 'production';

export type DeploymentConfig = {
    hostedEnvironment: HostedEnvironment;
    payPalClientId: string;
    showSecuritySettings: boolean;
};

export const getDeploymentConfig = (deployTarget?: string): DeploymentConfig => {
    const normalizedTarget = (deployTarget ?? 'development').trim().toLowerCase();
    const hostedEnvironment: HostedEnvironment =
        normalizedTarget === ''
            ? 'production'
            : normalizedTarget === 'test'
              ? 'test'
              : 'development';

    return {
        hostedEnvironment,
        payPalClientId:
            hostedEnvironment === 'production' ? PAYPAL_LIVE_CLIENT_ID : PAYPAL_SANDBOX_CLIENT_ID,
        showSecuritySettings: hostedEnvironment !== 'production',
    };
};

export const deploymentConfig = getDeploymentConfig(process.env.REACT_APP_DEPLOY_TARGET);
